<button *ngIf="button" class="btn-nieuwestroom" [disabled]="disabled" [ngClass]="{'btn-nieuwestroom-active': active }"
    [matTooltip]="button?.tooltip ?? null">
    <mat-icon *ngIf="button.icon" inline=true class="btn-nieuwestroom-maticon">{{button.icon}}</mat-icon>
    {{button.text}}
</button>